import { CHECK_TRANSIT_TIME } from "../../GraphQL/transitTIme";
import { ETransitStatusTypes } from "./@types";
import { useQuery } from "@apollo/client";
export type TTtransitTime = {
  approxTimeToComplete: number;
  localKey: ETransitStatusTypes;
  isMobile: boolean;
  clip: {
    clipTitle: string;
    game: number;
    trackId: string;
    status?: string;
  };
};

type TTransitTimeViewModelProps = {
  user?: string;
  clip?: string;
  spectating?: Record<string, any>;
  playerGameId?: string;
};

export const TransitTimeViewModel = ({
  user,
  clip,
  spectating,
  playerGameId,
}: TTransitTimeViewModelProps) => {
  const { data, error, loading, refetch } = useQuery(CHECK_TRANSIT_TIME, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
    skip: !user && !clip && !playerGameId,
    variables: {
      type: user || playerGameId ? "user" : "clip",
      user: user,
      playerGameId: playerGameId,
      clipIdentifier: clip,
    },
  });

  if (!spectating) {
    return {
      transitData: {
        myTransitTimes: (data?.transitTimeCheck as TTtransitTime[]) || [],
      },
      transitError: error,
      transitLoading: loading,
      refetch,
    };
  } else {
    return {
      transitData: {
        myTransitTimes: [spectating] as TTtransitTime[],
      },
    };
  }
};
